import { useNavigate } from "react-router-dom";
import { QdsSignaturesProps } from "./QdsSignatures.types";
import CardContainer from "../../components/card/CardContainer";
import { QdsSignatureCard } from "./QdsSignatureCard";

export const QdsSignatures = ({ documents, onDelete, onResend, mode = "signatures" }: QdsSignaturesProps) => {
  const navigate = useNavigate();

  return (
    <>
      {!!documents.length && (
        <section className="flex-column gap-2">
          <CardContainer
            children={[
              ...documents.map((item, i) => (
                <QdsSignatureCard
                  key={i}
                  qdsRequest={item.qdsRequest}
                  mode={mode}
                  onResend={() => {
                    onResend(item.id);
                  }}
                  onDelete={() => {
                    onDelete(item.qdsRequest?.id || -1);
                  }}
                  onClick={() => {
                    navigate(`/qds-signatures/${item.qdsRequest?.id}/sign`);
                  }}
                  id={item.qdsRequest?.id || -1}
                />
              )),
            ]}
            cardGap={16}
            cardMinWidth={300}
            cardMaxWidth={400}
            cardMaxNumberPerRow={3}
          />
        </section>
      )}
    </>
  );
};
